export const MuiTableCell = {
    styleOverrides: {
        head: ({ theme }) => ({
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "24px",
            letterSpacing: "0.17px",
            color: theme.palette.secondary.main,
            padding: "16px"
        }),
        root: ({ theme }) => ({
            borderBottom: "0",
            boxShadow: theme.shadows[3],
            padding: "4px 16px"
        })
    }
};
//# sourceMappingURL=TableCell.js.map